<template>
	<div>
		<div v-show="loadingStatus" class="loader-main">
			<div class="overlay-loader">
			<!-- <div class="loader">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div> -->
      <div class="loader"></div>
			</div>
		</div>
  		<terminalShow></terminalShow>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import terminalShow from './No-terminal'

export default {
  name: 'loader',
  computed: {
    ...mapGetters([
      'loadingStatus'
    ])
  },
  components: {
    terminalShow
  }
}
</script>

<style scoped>
  .loader-main {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    z-index: 1000;
  }

.overlay-loader {
	display: block;
	margin: auto;
	width: 50px;
	height: 50px;
	position: relative;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

.loader {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	width: 50px;
	height: 50px;
	animation-name: rotateAnim;
		-o-animation-name: rotateAnim;
		-ms-animation-name: rotateAnim;
		-webkit-animation-name: rotateAnim;
		-moz-animation-name: rotateAnim;
	animation-duration: 1.4s;
		-o-animation-duration: 1.4s;
		-ms-animation-duration: 1.4s;
		-webkit-animation-duration: 1.4s;
		-moz-animation-duration: 1.4s;
	animation-iteration-count: infinite;
		-o-animation-iteration-count: infinite;
		-ms-animation-iteration-count: infinite;
		-webkit-animation-iteration-count: infinite;
		-moz-animation-iteration-count: infinite;
	animation-timing-function: linear;
		-o-animation-timing-function: linear;
		-ms-animation-timing-function: linear;
		-webkit-animation-timing-function: linear;
		-moz-animation-timing-function: linear;
}
.loader div {
	width: 4px;
	height: 4px;
	border-radius: 50%;
	border: 0px solid #fff;
	position: absolute;
	top: 1px;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
}
.loader div:nth-child(odd) {
	border-top: none;
	border-left: none;
}
.loader div:nth-child(even) {
	border-bottom: none;
	border-right: none;
}
.loader div:nth-child(2) {
	border-width: 1px;
	left: 0px;
	top: -2px;
	width: 6px;
	height: 6px;
}
.loader div:nth-child(3) {
	border-width: 1px;
	left: -0px;
	top: 1px;
	width: 9px;
	height: 9px;
}
.loader div:nth-child(4) {
	border-width: 1px;
	left: -0px;
	top: -2px;
	width: 12px;
	height: 12px;
}
.loader div:nth-child(5) {
	border-width: 1px;
	left: -0px;
	top: 2px;
	width: 16px;
	height: 16px;
}
.loader div:nth-child(6) {
	border-width: 2px;
	left: 0px;
	top: -2px;
	width: 20px;
	height: 20px;
}
.loader div:nth-child(7) {
	border-width: 2px;
	left: 0px;
	top: 3px;
	width: 25px;
	height: 25px;
}


@keyframes rotateAnim {
	from {
		transform: rotate(360deg);
	}
	to {
		transform: rotate(0deg);
	}
}

@-o-keyframes rotateAnim {
	from {
		-o-transform: rotate(360deg);
	}
	to {
		-o-transform: rotate(0deg);
	}
}

@-ms-keyframes rotateAnim {
	from {
		-ms-transform: rotate(360deg);
	}
	to {
		-ms-transform: rotate(0deg);
	}
}

@-webkit-keyframes rotateAnim {
	from {
		-webkit-transform: rotate(360deg);
	}
	to {
		-webkit-transform: rotate(0deg);
	}
}

@-moz-keyframes rotateAnim {
	from {
		-moz-transform: rotate(360deg);
	}
	to {
		-moz-transform: rotate(0deg);
	}
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #880913;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media only screen and (min-width: 2000px) {
  .overlay-loader, .loader {
    width: 350px;
    height: 350px;
  }

  .loader div {
    width: 50px;
    height: 50px;
  }

  .loader div:nth-child(2) {
    border-width: 1px;
    left: 0px;
    top: -2px;
    width: 56px;
    height: 56px;
  }
  .loader div:nth-child(3) {
    border-width: 1px;
    left: -0px;
    top: 1px;
    width: 59px;
    height: 59px;
  }
  .loader div:nth-child(4) {
    border-width: 1px;
    left: -0px;
    top: -2px;
    width: 62px;
    height: 62px;
  }
  .loader div:nth-child(5) {
    border-width: 1px;
    left: -0px;
    top: 2px;
    width: 66px;
    height: 66px;
  }
  .loader div:nth-child(6) {
    border-width: 2px;
    left: 0px;
    top: -2px;
    width: 70px;
    height: 70px;
  }
  .loader div:nth-child(7) {
    border-width: 2px;
    left: 0px;
    top: 3px;
    width: 75px;
    height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue